<!--  -->
<template>
  <div>
    <div class="form_box">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="企业名称" label-width="90px">
          <el-input v-model="form.corp_name" />
        </el-form-item>
        <el-form-item label="企业ID" label-width="89px">
          <el-input v-model="form.corp_id" />
        </el-form-item>
        <el-form-item label="客服密钥" label-width="89px">
          <el-input v-model="form.secret" />
        </el-form-item>
        <el-form-item label="客服token" label-width="89px">
          <el-input v-model="form.token" />
        </el-form-item>
        <el-form-item label="客服aeskey" label-width="89px">
          <el-input v-model="form.aes_key" />
        </el-form-item>
        <el-form-item label="视频号" label-width="89px">
          <el-input v-model="form.video_account" />
        </el-form-item>
        <el-form-item label="客户联系secret" label-width="150px">
          <el-input v-model="form.customer_contact_secret" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="addcread">立即创建</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="padding:0 20px">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width:100%; height: 100%;"
        border
        max-height="500"
      >
        <el-table-column
          align="center"
          label="企业名称"
          prop="corp_name"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.isModify">{{ scope.row.corp_name }}</span>
            <el-input v-else v-model="scope.row.textCorpName" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="企业ID"
          width="100"
          prop="corp_id"
        >
          <template slot-scope="scope">
            <!-- <span v-if="!scope.row.isModify">{{ scope.row.corp_id }}</span> -->
            <el-popover
              v-if="!scope.row.isModify"
              placement="top-start"
              title="企业ID"
              width="200"
              trigger="hover"
              :content="scope.row.corp_id"
            >
              <p slot="reference" class="titip">{{ scope.row.corp_id }}</p>
            </el-popover>
            <el-input v-else v-model="scope.row.textCorpId" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="客服密钥"
          prop="secret"
        >
          <template slot-scope="scope">
            <!-- <span v-if="!scope.row.isModify">{{ scope.row.secret }}</span> -->
            <el-popover
              v-if="!scope.row.isModify"
              placement="top-start"
              title="客服密钥"
              width="200"
              trigger="hover"
              :content="scope.row.secret"
            >
              <p slot="reference" class="titip">{{ scope.row.secret }}</p>
            </el-popover>
            <el-input v-else v-model="scope.row.textSecret" />
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="客服token"
          prop="secret"
        >
          <template slot-scope="scope">
            <!-- <span v-if="!scope.row.isModify">{{ scope.row.token }}</span> -->
            <el-popover
              v-if="!scope.row.isModify"
              placement="top-start"
              title="客服token"
              width="200"
              trigger="hover"
              :content="scope.row.token"
            >
              <p slot="reference" class="titip">{{ scope.row.token }}</p>
            </el-popover>
            <el-input v-else v-model="scope.row.textToken" />
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="客服aeskey"
          prop="secret"
        >
          <template slot-scope="scope">
            <!-- <span v-if="!scope.row.isModify">{{ scope.row.aes_key }}</span> -->
            <el-popover
              v-if="!scope.row.isModify"
              placement="top-start"
              title="客服aeskey"
              width="200"
              trigger="hover"
              :content="scope.row.aes_key"
            >
              <p slot="reference" class="titip">{{ scope.row.aes_key }}</p>
            </el-popover>
            <el-input v-else v-model="scope.row.textAeskey " />
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="视频号"
          prop="secret"
        >
          <template slot-scope="scope">
            <!-- <span v-if="!scope.row.isModify">{{ scope.row.aes_key }}</span> -->
            <el-popover
              v-if="!scope.row.isModify"
              placement="top-start"
              title="视频号"
              width="200"
              trigger="hover"
              :content="scope.row.video_account"
            >
              <p slot="reference" class="titip">{{ scope.row.video_account }}</p>
            </el-popover>
            <el-input v-else v-model="scope.row.textvideoAccount " />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="客户联系secret"
          prop="secret"
        >
          <template slot-scope="scope">
            <!-- <span v-if="!scope.row.isModify">{{ scope.row.aes_key }}</span> -->
            <el-popover
              v-if="!scope.row.isModify"
              placement="top-start"
              title="客户联系secret"
              width="200"
              trigger="hover"
              :content="scope.row.customer_contact_secret"
            >
              <p slot="reference" class="titip">{{ scope.row.customer_contact_secret }}</p>
            </el-popover>
            <el-input v-else v-model="scope.row.customercontactSecret " />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="kf_count"
          label="系统客服数"
          width="80"
        />
        <el-table-column
          align="center"
          prop="real_kf_count"
          label="实际客服数"
          width="80"
        />
        <el-table-column
          align="center"
          label="客服开关"
          prop="secret"
        >
          <template slot-scope="scope">
            <!-- <el-switch
              v-model="scope.row.kf_status"
              :active-value="1"
              :inactive-value="9"
              :active-text="`${scope.row.kf_status === 1 ? '开启' : '关闭'}`"
            /> -->
            <div style="position: relative; display: inline-block;">
              <el-switch
                v-model="scope.row.kf_status"
                :width="20"
                active-color="#13ce66"
                inactive-color="rgb(191,191,191)"
                :active-value="1"
                :inactive-value="9"
                @change="statusChange(scope.row)"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :key="mathRandom"
          label="操作"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <span v-show="!scope.row.isModify">
              <el-button
                type="text"
                size="small"
                @click.native.prevent="scope.row.isModify = true"
              >
                修改
              </el-button>
              <el-button
                type="text"
                size="small"
                @click.native.prevent="deleteAccount(scope.row.id)"
              >
                删除
              </el-button>
              <!-- <el-button
                type="text"
                size="small"
                @click.native.prevent="kefukg(scope.row)"
              >

                客服开关（{{ scope.row.kf_status == 1 ? '已开' : '已关' }}）
              </el-button> -->

            </span>
            <span v-show="scope.row.isModify">
              <el-button
                type="text"
                size="small"
                @click.native.prevent="(scope.row.isModify = false),(scope.row.textCorpId = scope.row.corp_id),(scope.row.textCorpName = scope.row.corp_name),(scope.row.textSecret = scope.row.secret),(scope.row.textToken = scope.row.token),(scope.row.textAeskey = scope.row.aes_key),(scope.row.textvideoAccount = scope.row.video_account),(scope.row.customercontactSecret = scope.row.customer_contact_secret) "
              >
                取消修改
              </el-button>
              <el-button
                type="text"
                size="small"
                @click.native.prevent="confirmAccount(scope.row)"
              >
                确认修改
              </el-button>
            </span>
            <span v-show="!scope.row.isModify">
              <el-button
                type="text"
                size="small"
                @click.native.prevent="updateDepartment(scope.row.corp_id)"
              >
                更新部门
              </el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { getMicroEnterprise, newEnterpriseAndMicro, delteMicro, wechatcomupdataaccountr, updateDepartment } from '@/api/providerAccountManagement/servicePorviderList1.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      form: {
        corp_name: '',
        corp_id: '',
        secret: '',
        token: '',
        aes_key: '',
        video_account: '',
        customer_contact_secret: ''
      },
      stutes: null,
      pwdFlag: true, // 密码标示 true表示当前是密码形式
      account_name: '',
      login_pwd: '',
      pay_pwd: '',
      mathRandom: null,
      tableData: [],
      loading: false,
      query: {
        page: 1,
        pageSize: 10,
        company_name: null
      },
      total: null,

      company_name: '',
      ster: null
    }
  },
  created() {
    this.accountlist()
  },
  mounted() {

  },
  methods: {
    async accountlist() {
      this.loading = true
      const data = await getMicroEnterprise(this.query)
      for (let i = 0; i < data.data.list.length; i++) {
        data.data.list[i].textCorpId = data.data.list[i].corp_id
        data.data.list[i].textCorpName = data.data.list[i].corp_name
        data.data.list[i].textSecret = data.data.list[i].secret
        data.data.list[i].textToken = data.data.list[i].token
        data.data.list[i].textAeskey = data.data.list[i].aes_key
        data.data.list[i].textvideoAccount = data.data.list[i].video_account
        data.data.list[i].customercontactSecret = data.data.list[i].customer_contact_secret

        data.data.list[i].isModify = false
      }
      this.loading = false
      this.tableData = data.data.list
      this.total = data.data.total
    },
    async addcread() {
      if (this.form.corp_name === '') {
        this.$message.error('请填写企业名称')
        return
      }
      if (this.form.corp_id === '') {
        this.$message.error('请填写企业ID')
        return
      }
      if (this.form.secret === '') {
        this.$message.error('请填写客服密钥')
        return
      }
      if (this.form.token === '') {
        this.$message.error('请填写客服token')
        return
      }
      if (this.form.aes_key === '') {
        this.$message.error('请填写客服aeskey')
        return
      }
      if (this.form.video_account === '') {
        this.$message.error('请填写视频号')
        return
      }
      if (this.form.customer_contact_secret === '') {
        this.$message.error('请填写客户联系secret')
        return
      }

      await newEnterpriseAndMicro(this.form)
      this.accountlist()
      this.rest()
      this.$message({
        message: '添加成功',
        type: 'success'
      })
    },

    rest() {
      this.form.corp_name = ''
      this.form.corp_id = ''
      this.form.secret = ''
      this.form.token = ''
      this.form.aes_key = ''
      this.form.video_account = ''
      this.form.customer_contact_secret = ''
    },

    // 确定修改
    async confirmAccount(item) {
      // const id = item.id
      console.log('56555', item)
      if (item.textvideoAccount === '') {
        this.$message.error('请填写视频号')
        return
      }
      const data = await wechatcomupdataaccountr({
        id: item.id,
        corp_id: item.textCorpId,
        corp_name: item.textCorpName,
        secret: item.textSecret,
        token: item.textToken,
        aes_key: item.textAeskey,
        video_account: item.textvideoAccount,
        customer_contact_secret: item.customercontactSecret
      })
      this.accountlist()
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      console.log(data)
    },

    // 删除
    async deleteAccount(id) {
      await delteMicro(id)
      this.$message({
        message: '删除成功',
        type: 'success'
      })
      this.accountlist()
    },

    async updateDepartment(id) {
      await updateDepartment({ corp_id: id })
      await this.accountlist()
      this.$message({
        message: '更新成功',
        type: 'success'
      })
    },

    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.accountlist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.accountlist()
    },
    resback() {
      this.rest()
    },
    async statusChange(item) {
      console.log('item', item.kf_status)
      const data = await wechatcomupdataaccountr({
        id: item.id,
        corp_id: item.textCorpId,
        corp_name: item.textCorpName,
        secret: item.textSecret,
        token: item.textToken,
        aes_key: item.textAeskey,
        video_account: item.textvideoAccount,
        customer_contact_secret: item.customercontactSecret,
        kf_status: item.kf_status === 1 ? 1 : 9
      })
      this.accountlist()
      this.$message({
        message: '操作成功',
        type: 'success'
      })
      console.log(data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.form_box{
  /* margin-top: 30px; */
  padding: 10px 10px 0px 10px;
}
 ::v-deep .el-switch__core{
    width: 70px !important;
}
.titip{
    width: 126px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; /* 这里是超出几行省略 */
    overflow: hidden;
}
</style>
